import { Component } from '@angular/core';
import { StatusButtons } from '../../../_shared/interfaces';
import { NgForOf } from "@angular/common";
import { RequestsOverviewComponent } from "./requests-overview/requests-overview.component";

@Component({
  selector: 'app-requests',
  standalone: true,
  imports: [
    NgForOf,
    RequestsOverviewComponent
  ],
  templateUrl: './requests.component.html',
  styleUrl: './requests.component.sass'
})
export class RequestsComponent {
  status: string = 'running';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'alert-info', icon: 'info-circle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'answered', display: 'Beantwortet', label: 'alert-info', icon: 'info-circle'},
    { state: 'favored', display: 'Auftrag', label: 'alert-success', icon: 'check-circle'},
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }
}
